import { Accordion } from '../../../../../components/general/accordion';
import SpaIcon from '@mui/icons-material/Spa';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrFinalCausalityProps } from './props';
import { usePqrFinalCausality } from './hook';

export const PqrDataFinalCausality = ({
    finalCausality,
}: PqrFinalCausalityProps) => {
    const { formik } = usePqrFinalCausality(finalCausality);

    return (
        <Accordion
            title="CAUSALIDAD FINAL"
            icon={<SpaIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Causalidad"
                        name="causality"
                        size="small"
                        value={formik.values.causality}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Motivo"
                        name="motive"
                        size="small"
                        value={formik.values.motive}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Amparo"
                        name="protection"
                        size="small"
                        value={formik.values.protection}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
